import { IconEye, IconEyeOff } from '@tabler/icons-react'; // Import the eye-off icon as well
import React, { useState } from 'react';
import {
  Input,
  InputContainer,
} from './styles';

type InputLoginProps = {
  value?: string;
  icon?: React.ReactNode;
  placeholder: string;
  handler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  autoComplete?: string;
}

export default function InputLogin({ value, icon, placeholder, handler, type, autoComplete }: InputLoginProps) {
  const [showpass, setShowpass] = useState(false);

  const toggleShowpass = () => {
    setShowpass(!showpass);
  };

  return (
    <InputContainer>
      {icon}
      <Input value={value} autoComplete={autoComplete ? autoComplete : ''} placeholder={placeholder} onChange={handler} type={showpass ? 'text' : type} /> {/* Toggle between 'text' and original type */}
      {type === "password" ? (
        <div onClick={toggleShowpass}>
          {showpass ? <IconEye size={24} color={"#A0A0A0"} /> : <IconEyeOff size={24} color={"#A0A0A0"} />}
        </div>
      ) : null}
    </InputContainer>
  );
}
